export default {
    error_msg: (state) => state.error_msg,
    success: (state) => state.success,
    phone: (state) => state.phone,
    email: (state) => state.email,
    code: (state) => state.code
}
